import axios from "axios";
import { ARHIVA_REST_URL } from "../../../../../../../environments/environment";
export function searchData(data) {
  return axios.post(`${ARHIVA_REST_URL}api/search/results`, data);
}
